"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var SelectInput = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement("select", { value: store.value, name: store.name, onChange: store.handleChange, onBlur: store.handleBlur, className: store.className },
        react_1.default.createElement("option", { value: "" }, "\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"),
        store.optionStores.map(function (store, idx) { return (react_1.default.createElement("option", { key: idx, value: store.value }, store.label)); }),
        react_1.default.createElement("optgroup", null)));
});
exports.default = SelectInput;
